import { all, takeLatest, call } from 'redux-saga/effects'
import getBrand from 'services/brand'
import fetchData from '../helpers/fetchData'
import actions from './actions'

function* fetchBrand({ payload }) {
  const service = () => getBrand(payload)
  yield call(fetchData, actions.brandApiName, service)
}

export default function* rootSaga() {
  yield all([takeLatest(actions.requestBrand, fetchBrand)])
}
